/**
 * @license
 * Copyright 2020 Google Inc.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @internal
 */
export const PUPPETEER_REVISIONS = Object.freeze({
  chrome: '148.0.7778.97',
  'chrome-headless-shell': '148.0.7778.97',
  firefox: 'stable_150.0.2',
});
